import { motion } from 'framer-motion';
import {
  FileText,
  Cloud,
  Brain,
  Code,
  Globe,
  Smartphone,
  Box,
  Shield,
  Network,
  Briefcase,
  Settings,
  Database,
  Zap,
  GitBranch,
  Layout,
  GraduationCap,
  BarChart3,
  Cpu,
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: FileText,
      title: 'Technical Writing & Research Support',
      color: 'blue',
    },
    { icon: Cloud, title: 'Cloud Architecture Consulting', color: 'red' },
    { icon: Brain, title: 'ML/AI Engineering', color: 'blue' },
    {
      icon: Code,
      title: 'Enterprise Software Development',
      color: 'red',
    },
    { icon: Globe, title: 'Web Development', color: 'blue' },
    { icon: Smartphone, title: 'Mobile Development', color: 'red' },
    { icon: Box, title: 'SaaS Development', color: 'blue' },
    {
      icon: Shield,
      title: 'Cybersecurity & Network Engineering',
      color: 'red',
    },
    { icon: Network, title: 'IT Consulting', color: 'blue' },
    { icon: GitBranch, title: 'DevOps & CI/CD Consulting', color: 'red' },
    { icon: Database, title: 'Data Engineering & Analytics', color: 'blue' },
    { icon: Layout, title: 'System Architecture & Design', color: 'red' },
    { icon: Zap, title: 'Performance Optimization', color: 'blue' },
    { icon: Settings, title: 'API Design & Development', color: 'red' },
    { icon: GraduationCap, title: 'Technical Training & Mentoring', color: 'blue' },
    { icon: BarChart3, title: 'Data Science Consulting', color: 'red' },
    { icon: Cpu, title: 'Software System Integration', color: 'blue' },
    { icon: Briefcase, title: 'Technology Strategy & Advisory', color: 'red' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 20 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section
      id="services"
      className="bg-gradient-to-b from-black to-gray-900 px-4 py-20 sm:px-6 lg:px-8"
    >
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 text-center"
        >
          <h2 className="mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl">
            Services
          </h2>
          <div className="mx-auto h-1 w-24 bg-gradient-to-r from-blue-500 to-red-500"></div>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
        >
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={index}
                variants={itemVariants}
                whileHover={{ scale: 1.05, rotateY: 5, y: -5 }}
                className={`group rounded-xl border border-white/10 bg-white/5 p-6 backdrop-blur-md transition-all duration-300 hover:bg-white/10 ${
                  service.color === 'blue' ? 'hover:border-blue-500/50' : 'hover:border-red-500/50'
                }`}
              >
                <div
                  className={`mb-4 inline-flex rounded-lg p-3 ${
                    service.color === 'blue'
                      ? 'bg-blue-500/20 text-blue-400 group-hover:bg-blue-500/30'
                      : 'bg-red-500/20 text-red-400 group-hover:bg-red-500/30'
                  } transition-all`}
                >
                  <Icon className="h-6 w-6" />
                </div>
                <h3
                  className={`text-lg font-bold ${
                    service.color === 'blue'
                      ? 'text-white group-hover:text-blue-400'
                      : 'text-white group-hover:text-red-400'
                  } transition-colors`}
                >
                  {service.title}
                </h3>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
